// extracted by mini-css-extract-plugin
module.exports = {"workCultureSection":"cc_g3","headerSection":"cc_2","workCultureList":"cc_g4","workCultureListContainer":"cc_g5","contentCard":"cc_g6","title":"cc_S","description":"cc_k"};